/**
 * Google 갱신 토큰 보관: vault 데이터 키로 암호화해 이 기기에만 저장한다.
 * (평문 저장 금지, 잠금 상태에서는 꺼낼 수 없음)
 */
import { openJson, sealJson, type DataKey, type Envelope } from '../crypto/envelope';
import type { CounselDb } from '../db/schema';

const KEY = 'sync.refreshToken';
const aad = (vaultId: string) => `counselai|oauth-refresh|${vaultId}`;

type Ctx = { db: CounselDb; dataKey: DataKey; vaultId: string };

export async function saveRefreshToken(ctx: Ctx, token: string | null): Promise<void> {
  if (!token) {
    await ctx.db.meta.delete(KEY);
    return;
  }
  await ctx.db.meta.put({ key: KEY, value: await sealJson(ctx.dataKey, { token }, aad(ctx.vaultId)) });
}

export async function loadRefreshToken(ctx: Ctx): Promise<string | null> {
  const row = await ctx.db.meta.get(KEY);
  if (!row) return null;
  try {
    return (await openJson<{ token: string }>(ctx.dataKey, row.value as Envelope, aad(ctx.vaultId))).token;
  } catch {
    return null;
  }
}
